module.exports = __webpack_public_path__ + "static/img/phone.a009b185.svg";